<template>
  <OmitBlock :element="listElement">
    <ul v-if="!ordered">
      <ListItem
        v-for="(listItem, index) in listElement.listItems"
        :key="index"
        :listItem="listItem"
        :entryItems="entryItems"
        @updated="updated($event)"
      />
    </ul>
    <ol v-if="ordered" :type="typeOrdered">
      <ListItem
        v-for="(listItem, index) in listElement.listItems"
        :key="index"
        :listItem="listItem"
        :entryItems="entryItems"
        @updated="updated($event)"
      />
    </ol>
  </OmitBlock>
</template>

<script>
import ListItem from "@/components/document/fill/block/ListItem";
import OmitBlock from "@/components/document/fill/OmitBlock";
export default {
  name: "ListElement",
  props: ["listElement", "entryItems"],
  computed: {
    ordered() {
      if (this.listElement.type && this.listElement.type == "ordered") {
        return true;
      }
      return false;
    },
    typeOrdered() {
      if (this.listElement.typeordered) {
        return this.listElement.typeordered;
      }
      return "1";
    }
  },
  components: {
    ListItem,
    OmitBlock
  },
  methods: {
    updated(event) {
      this.$emit("updated", event);
    }
  }
};
</script>
